/**
 *Created by jmmartinez on 29/06/120
 * v.2.0  30/09/2020 Cambiado a framework2
 * v.2.1 02/12/2020 Import "../../resources/css/combobox.css" para que coja el popoverClass
 * v.2.2 07/04/2021 Creado el método asignarElementoSeleccionado al que se llama tras cargar los objetos.
 * v.2.3 18/07/2022 Añadida propiedad url, para especificar de donde cargar los objetos.
 *                  Modificado método load para tener en cuenta la propiedad load.
 * v.2.4 05/09/2023 Cambiado para usar el nuevo combox basado en react-select
 *                  Creadas nuevas propiedades label y labelInline
 * v.2.5 30/01/2024 En asignarElementoSeleccionado si no se encuentra el elemento, no se asigna y el ValorInicial se cambia a 0.
 *                 Modificado load para usar el parámetro pausaLoad y doPostPausa de ClientRestful
 * */

import React from 'react'
import PropTypes from 'prop-types';

import "../../resources/css/combobox.css";
//import ComboBox from "../../blueprint/ComboBox";
import ComboBox from "./ComboBox";
import ClienteRestful from "../network/ClienteRestful";
import {filtrarConNombreCampo} from "../utils/FilterUtils"
import {getFiltroFromCampo, getFiltroInicialFromCampoFECHAPERIODO} from "../utils/FiltroGridUtils";
import {primerElementoConValorPropiedad} from "../utils/ArrayUtils";
import {FILTRO_MAYOR} from "./FormularioGridBusqueda";


class ComboBoxClase extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: props.id,
            placeholder: props.placeholder,
            titulo: props.titulo,
            campoClave: props.campoValor,
            campoMostrar: props.campoMostrar,
            campoIdMostrar: props.campoIdMostrar,
            valor: props.valor,
            valorInicial: props.valorInicial,
            elementos: [],
            elementoSeleccionado: props.valor,
            cargandoDatos: false,
            noMostrarCero: true,
            itemSelected: null,
            label: props.label,
            labelInline: props.labelInline,
        }
    }

    componentDidMount() {
        const {clase} = this.props;
        let pos= clase.lastIndexOf(".")+1;
        let claseSimple= clase.substr(pos);
        this.setState({claseSimple: claseSimple} , () => this.load());
    }

    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.valor !== prevState.valor) {
            newState.valor = nextProps.valor;
        }
        if (nextProps.valorInicial !== prevState.valorInicial) {
            newState.valorInicial = nextProps.valorInicial;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    load = () => {
        const {claseSimple, noMostrarCero} = this.state;
        const {urlServicioRestful, url, condiciones, campoMostrar, pausaLoad} = this.props;
        //console.log("urlServicioRestful: ", urlServicioRestful);
        let urlReal= url ? url : urlServicioRestful + "list/" + claseSimple;


        const clienteRestful = new ClienteRestful().setUrl(urlReal);

        //console.log("+++++++++++ ComboBoxClase LOAD ", claseSimple);
        //console.log("condiciones: ", condiciones);
        //console.log("url", url);

        var filtro= {condiciones: [], orden: []};
        condiciones && condiciones.forEach ( (campo) => {
            //console.log("campo: ", campo);
            if (campo.valor)  {
                //console.log("A");
                let filtroCampo = getFiltroFromCampo(campo, campo.valor, campo.valor2);
                //console.log("filtroCampo: ", filtroCampo);
                if (filtroCampo)
                    filtro.condiciones.push(filtroCampo);
            }
            if (campo.tipoValor){
                //console.log("B");
                let filtroCampo=  getFiltroInicialFromCampoFECHAPERIODO(campo);
                if (filtroCampo)
                    filtro.condiciones.push(filtroCampo);
            }
        });
        filtro.orden.push({nombreCampo: campoMostrar, asc: true});

        //Añadimos condicion de cero inmutable
        if (noMostrarCero){
            //console.log("NON CERO")
            filtro.condiciones.push(
                {nombreCampo: "codigo", tipo: FILTRO_MAYOR,  valor: 0}
            );
        }

        let pausaLoadRealms= pausaLoad ? pausaLoad * 1000 : 0 ;
        clienteRestful.doPostPausa(pausaLoadRealms,  filtro, response => {
            //console.log("response: ", response);
            if (clienteRestful.exito && response){
                let newElementos= response;
                //console.log("resultado: ", newElementos);
                this.setState({cargandoDatos: false, elementos: newElementos}, () => {
                    this.asignarElementoSeleccionado();
                });

            }
        });


    }

    asignarElementoSeleccionado= () => {
        const {elementos, valorInicial} = this.state;
        //console.log("**** ASIGNARELEMENTOSELECCIONADO: ****");
        //console.log("elementos: ", elementos);
        //console.log("valorInicial: ", valorInicial);
        if (elementos && valorInicial) {
            let newItemSelected = primerElementoConValorPropiedad(elementos, "codigo", valorInicial);
            console.log("newItemSelected: ", newItemSelected);
            if (!newItemSelected){
                console.log("Item No Encontrado");
                this.setState({valorInicial: 0});
            }
            else {
                this.setState({itemSelected: newItemSelected});
            }
        }
    }


    onValueChanged= (objeto) => {
        const {onValueChanged} = this.props;
        this.setState({ itemSelected : objeto });
        onValueChanged && onValueChanged(objeto);
    }

    render() {
        const {id, placeholder, elementos, campoMostrar, campoIdMostrar, campoClave, itemSelected, label, labelInline} = this.state;
        const{mostrarEliminar} = this.props;
        //let itemSelected= this.getItemSelectedFromEnumCodigo(elementos, enumCodigo);

        //console.log("COMBOBOXCLASE");
        //console.log("elementos: ", elementos);
        //console.log("id: ", id);
        //console.log("itemSelected: ", itemSelected);

        return (
            <div>
            {   elementos && elementos.length > 0 &&
                <ComboBox
                    id= {id}
                    fieldText={campoMostrar}
                    fieldKey={campoClave}
                    fieldLabel={campoIdMostrar}
                    items={elementos}
                    onValueChanged={this.onValueChanged}
                    placeholder= {placeholder}
                    filterable={false}
                    popoverClassName="popover"
                    itemSelected= {itemSelected}
                    label={label}
                    labelInline={labelInline}
                    mostrarEliminar={mostrarEliminar}
                />
            }
            </div>
        );
    }
}


ComboBoxClase.propTypes = {
    clase: PropTypes.string.isRequired,
    titulo: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    campoClave: PropTypes.string.isRequired,
    campoMostrar: PropTypes.string.isRequired,
    valor: PropTypes.object,
    valorInicial: PropTypes.object,
    icon: PropTypes.string,
    urlServicioRestful: PropTypes.string.isRequired, //path prefijo al que se le añade la clase
    url: PropTypes.string,  //Path absoluto
    condiciones: PropTypes.array,
    obligatorio: PropTypes.bool,
    onValueChanged: PropTypes.func,
    label: PropTypes.string,
    labelInline: PropTypes.bool,
    mostrarEliminar: PropTypes.bool,
    pausaLoad: PropTypes.number
}

export default ComboBoxClase;